import { render, staticRenderFns } from "./SharePeer.vue?vue&type=template&id=391b9b36&"
import script from "./SharePeer.vue?vue&type=script&lang=ts&"
export * from "./SharePeer.vue?vue&type=script&lang=ts&"
import style0 from "./SharePeer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports